module.exports = __webpack_public_path__ + "img/627.84167069.png";